import axios from "axios";
import moment from "moment";
import React, { useContext, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ContextAll } from "../../saveFile/saveFile";
import { addErrorField } from "../../../redux/slices/settings";

const SaveButton = ({ id }) => {
  const { settings, lang, locale, errorFields } = useSelector((state) => ({
    settings: state.settings,
    lang: state.changeLang.language.restriction,
    locale: state.changeLang.change,
    errorFields: state.settings.errorFields,
  }));
  const dispatch = useDispatch();
  const { settingsFile } = useContext(ContextAll);
  const [isUpdateLoad, setIsUpdateLoad] = useState(false);

  const isSaveBtnDisabled =
    errorFields.includes("uniqueScans") &&
    settings.scanLimits.isScanLimits &&
    !settings.scanLimits.uniqueScans.length;

  const handleSave = async () => {
    if (
      settings.scanLimits.isScanLimits &&
      !settings.scanLimits.uniqueScans.length
    ) {
      dispatch(addErrorField("uniqueScans"));
      return;
    }
    const formData = new FormData();
    formData.append("tab", "restriction");
    formData.append("checkboxLimits", settings.scanLimits.isScanLimits ? 1 : 0);
    formData.append("uniqueScans", settings.scanLimits.uniqueScans);
    formData.append("limitHint", settings.scanLimits.errorMessage);
    formData.append("isExactRequired", settings.location.isLocation ? 1 : 0);
    formData.append("isExactCheck", settings.location.isAskLocation ? 1 : 0);
    formData.append("locationHint", settings.location.locationMessage);
    formData.append("checkboxPassword", settings.password.isPassword ? 1 : 0);
    formData.append("password", settings.password.value);
    formData.append("passwordHint", settings.password.hintText);
    formData.append("checkboxExpired", settings.expiration.isExpirationDate ? 1 : 0);
    formData.append("expiredDate", settings.expiration.expiredDate);

    const scheduleAccessObj = {
      scheduleAccess: settings.schedule.isSchedule,
      id: settings.schedule.id,
      showNothing: settings.schedule.isShowNothing,
      timezone: settings.schedule.timezone,
    };
    if (settings.schedule.dateStart) {
      scheduleAccessObj.dateStart = moment(
        settings.schedule.dateStart
      ).toString();
    }
    if (settings.schedule.dateEnd) {
      scheduleAccessObj.dateEnd = moment(settings.schedule.dateEnd).toString();
    }

    let count = 1;
    const schedules = {};
    settings.schedule.days.forEach((item) => {
      item.forEach((el) => {
        if (!el.isActive) {
          return;
        }
        schedules[count] = {
          day: el.day,
          isActive: el.isActive,
          dateStart: el.dateStart || null,
          dateEnd: el.dateEnd || null,
        };
        count += 1;
      });
    });
    if (Object.keys(schedules).length > 0) {
      scheduleAccessObj.schedules = schedules;
    }

    if (settings.schedule.type.file) {
      formData.append(
        "file",
        settingsFile[0]?.file ? settingsFile[0].file : ""
      );
    }
    if (settings.schedule.type.link) {
      scheduleAccessObj.link = settings.schedule.contentText;
    }
    formData.append("scheduleAccessObj", JSON.stringify(scheduleAccessObj));

    const locationObjects = {};
    settings.location.points.forEach((item, index) => {
      const id = item.id.toString().includes("generator")
        ? {}
        : { id: item.id };
      locationObjects[index + 1] = {
        ...id,
        latitude: item.lat,
        longitude: item.long,
        radius: item.range,
        rule: item.rule,
        city: item.cityId,
        country: item.countryId,
      };
    });
    Object.keys(locationObjects).length > 0 &&
      formData.append("locationObjects", JSON.stringify(locationObjects));
    formData.append("_locale", locale);

    try {
      setIsUpdateLoad(true);
      if (id) {
        await axios.post(`/folder/settings/${id}/update`, formData);
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        const ids = urlParams.get("id");
        const arrayOfIds = ids.split(",");
        arrayOfIds.map((x) => formData.append("id[]", x));
        await axios.post(`/entry/settings/update`, formData);
      }
      showSuccessAlert();
    } catch (e) {
      showErrorAlert(e?.response?.data?.error || lang[37]);
    } finally {
      setIsUpdateLoad(false);
    }
  };

  const showSuccessAlert = () => {
    const successAlert = document.querySelector(
      '[data-admin--qrsettings-target="alert"]'
    );
    if (!successAlert) {
      return;
    }
    successAlert.classList.remove("d-none");
    setTimeout(() => successAlert.classList.add("d-none"), 5000);
  };

  const showErrorAlert = (message) => {
    const alert = document.querySelector(
      '[data-admin--qrsettings-target="alertError"]'
    );
    if (!alert) {
      return;
    }
    const error = alert.querySelector(".error");
    error.innerHTML = message;
    alert.classList.remove("d-none");
    setTimeout(() => {
      alert.classList.add("d-none");
      error.innerHTML = "";
    }, 5000);
  };

  return (
    <Col lg={4} className="mx-auto pb-4">
      <Button
        variant="primary"
        className="fw-bold py-3 w-100 text-capitalize"
        onClick={handleSave}
        disabled={
          settings.restrictionsLoading === "load" ||
          isUpdateLoad ||
          isSaveBtnDisabled
        }
      >
        {lang[36]}
      </Button>
    </Col>
  );
};

export default SaveButton;
